module.exports = __webpack_public_path__ + "static/media/crowd-vision-thumbnail.7df1fc60.png";